
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {
data (){
return {
openid:'',
phone:''
}
},
beforeMount(){
if(this.$router.history.current.path == "/rapireMultiplePage"){
document.title = "我的报修";
}
this.openid = this.$router.history.current.query.openid,
this.phone = this.$router.history.current.query.phone
},
components:{
Flexbox,
FlexboxItem
}
}



// WEBPACK FOOTER //
// ./src/components/repairComponents/rapireMultiplePage.vue